import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import type { IApiResponse } from "@/types";
import type { IEmployeeDigitalAccess } from "@/types/(company)/onboarding-settings";
import { API_MS_MY_DIGITAL_ACCESS, API_MS_MY_DIGITAL_ACCESS_ALL } from "@/constants/apiEndpoints";

export const msOnboardingSettingsApi = createApi({
  reducerPath: "msOnboardingSettingsApi",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,
  tagTypes: ["msMyDigitalAccess"],
  endpoints: (builder) => ({
    msGetMyDigitalAccess: builder.query<IApiResponse<IEmployeeDigitalAccess[]>, void>({
      query: () => ({ url: API_MS_MY_DIGITAL_ACCESS }),
      providesTags: ["msMyDigitalAccess"],
    }),
    msGetMyDigitalAccessAll: builder.query<IApiResponse<IEmployeeDigitalAccess[]>, void>({
      query: () => ({ url: API_MS_MY_DIGITAL_ACCESS_ALL }),
      providesTags: ["msMyDigitalAccess"],
    }),
  }),
});

export const {
  useMsGetMyDigitalAccessQuery,
  useMsGetMyDigitalAccessAllQuery,
} = msOnboardingSettingsApi;
